import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AuthModal = _resolveComponent("AuthModal")!
  const _component_PopupNotification = _resolveComponent("PopupNotification")!
  const _component_MobileFiltersModal = _resolveComponent("MobileFiltersModal")!
  const _component_SignUpReportLoadingModal = _resolveComponent("SignUpReportLoadingModal")!
  const _component_SignUpReportSuccessModal = _resolveComponent("SignUpReportSuccessModal")!
  const _component_SignUpReportFailureModal = _resolveComponent("SignUpReportFailureModal")!
  const _component_SignUpReportCustomerModal = _resolveComponent("SignUpReportCustomerModal")!
  const _component_SignUpReportCancelledModal = _resolveComponent("SignUpReportCancelledModal")!
  const _component_SetupTariffsModal = _resolveComponent("SetupTariffsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_AuthModal),
    _createVNode(_component_PopupNotification),
    _createVNode(_component_MobileFiltersModal),
    _createVNode(_component_SignUpReportLoadingModal),
    _createVNode(_component_SignUpReportSuccessModal),
    _createVNode(_component_SignUpReportFailureModal),
    _createVNode(_component_SignUpReportCustomerModal),
    _createVNode(_component_SignUpReportCancelledModal),
    _createVNode(_component_SetupTariffsModal)
  ], 64))
}